<template>
	<!-- <div v-loading="loading" class="content_list" :class="agentMobile?'content_list_lg':''">

		<div class="normal-list" v-if="listData.length>0">
			<navCard
				v-for="(item, index) in listData"
				:key="index"
				:navIndex="index"
				:navId="item.id"
				:title="item.type"
				:hospitalName="item.hospital"
				:checkTime="item.time"
				:dep="item.dep"
				:searchType="searchType"
				@toDetail="getIndex"
				>
			</navCard>
		</div>
		<div class="normal_list" v-else>
			<div class="list_none">暂无记录</div>
		</div>
	</div> -->
    <iframe :src="url" frameborder="no" scrolling="no" allowtransparency="yes"></iframe>
</template>

<script>
import {getPatientInfo} from '../../../../api/appletApi'
import navCard from '../../components/navCard.vue'
export default {
  components: {
    navCard
  },
  data () {
    return {
      agentMobile: '',
      hospital: '',
      start: '',
      end: '',
      type: [],
      searchType: 'image',
      loading: false,
      url: '',
      listData: [
        // {
        // 	type: '四肢骨关节',
        // 	titType: '四肢骨关节',
        // 	hospital: '温州医科大学附属第一医院',
        // 	time: '2020/07/15  14:00',
        // 	dep: 'CT'
        // },{
        // 	type: '四肢骨关节',
        // 	titType: '四肢骨关节',
        // 	hospital: '温州医科大学附属第一医院',
        // 	time: '2020/07/18  14:00',
        // 	dep: 'DG'
        // },{
        // 	type: 'MRI报告',
        // 	titType: 'MRI报告',
        // 	hospital: '温州医科大学附属第二医院',
        // 	time: '2020/07/15  14:00',
        // 	dep: 'DSA'
        // }
      ]
    }
  },
  computed: {
  },
  created () {
    // this.getList()
    this.url = this.$route.query.url
  },
  methods: {
    getList () {
      /* let mpi = uni.getStorageSync('mpi')
      let patName = uni.getStorageSync('patientName') */
      let mpi = this.$route.query.mpi
      let patName = this.$route.query.patientName
      let data = {
        'Header': 'MCIP_JC_JIANCHABGCX',
        'Body': {
          'MPI': mpi,

          'XingMing': patName
        }
      }
      /* uni.showLoading({
			    title: '加载中...'
      }) */
      this.loading = true
      let that = this
      getPatientInfo(data).then(data => {
        // uni.hideLoading()
        this.loading = false
        let list = data.jianChaBGList

        list.forEach((item, index) => {
          let info = {
            type: item.jianChaBWDM,
            hospital: item.baoGaoJGMC,
            time: item.baoGaoSJ,
            dep: item.zhiXingKSMC
          }

          that.listData.push(info)
        })
      })
    },
    getIndex (res) {
      console.log(res)
    }
  }

}
</script>

<style>
/* page{
	background-color: #f6f6f6;
} */
.normal-list{
	margin-top: 12px;
	padding:0 12px;
}
.list_none{
	width: 100%;
	text-align: center;
	font-size: 14px;
	color: #666;
	padding: 50px 0;
}
iframe{
    width:calc(100% - 0px);
    height: calc(100% - 5px);
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/image/image.vue